import React, { useEffect } from 'react';
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu';
import styled from 'styled-components';

const StyledHorizontalScroll = styled.div`
  position: relative;
  scrollbar-width: 0;

  .scroll {
    margin-top: 3em;
    scrollbar-width: 0;

    &::-webkit-scrollbar {
      display: none;
    }

    /* Hide scrollbar for IE, Edge and Firefox */
    & {
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
    }
  }

  .wrapper {
    scrollbar-width: 0;
  }

  .seperator {
    width: 2em;
  }

  .control {
    position: absolute;
    right: 0;
    font-weight: 600;
    background-color: ${({ theme }) => theme.primaryLink};
    color: white;
    padding: 0.1em 0.8em;
    border-radius: 5px;

    &:first-child {
      margin-right: 1em;
    }

    &.left {
      right: 2em;
    }

    @media screen and (min-width: 568px) {
      top: 0em;
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .item {
    width: 100%;
  }
`;

export function HorizontalScroll({ title, data, render, itemClassName }) {
  const [items, setItems] = React.useState([]);
  const [selected, setSelected] = React.useState([]);
  const isItemSelected = (id) => !!selected.find((el) => el === id);

  useEffect(() => {
    if (data && typeof data.map === 'function') {
      setItems(data);
    }
  }, [data]);

  const handleClick = (id) => () => {
    const itemSelected = isItemSelected(id);

    setSelected((currentSelected) =>
      itemSelected ? currentSelected.filter((el) => el !== id) : currentSelected.concat(id)
    );
  };

  return (
    <StyledHorizontalScroll>
      <div>{title}</div>
      <ScrollMenu
        LeftArrow={makeLeftArrow('control left')}
        RightArrow={makeRightArrow('control right')}
        scrollContainerClassName="scroll"
        separatorClassName="seperator"
        wrapperClassName="wrapper"
        itemClassName="item">
        {items.map((item) => {
          return (
            <Card
              itemId={item.id} // NOTE: itemId is required for track items
              title={item.id}
              key={item.id}
              onClick={handleClick(item.id)}
              selected={isItemSelected(item.id)}
              className={itemClassName}>
              {render(item)}
            </Card>
          );
        })}
      </ScrollMenu>
    </StyledHorizontalScroll>
  );
}

function makeLeftArrow(className) {
  return function LeftArrow() {
    const { isFirstItemVisible, scrollPrev } = React.useContext(VisibilityContext);

    return (
      <button className={className} disabled={isFirstItemVisible} onClick={() => scrollPrev()}>
        {'<'}
      </button>
    );
  };
}

function makeRightArrow(className) {
  return function RightArrow() {
    const { isLastItemVisible, scrollNext } = React.useContext(VisibilityContext);

    return (
      <button className={className} disabled={isLastItemVisible} onClick={() => scrollNext()}>
        {'>'}
      </button>
    );
  };
}

function Card({ onClick, children, className }) {
  const visibility = React.useContext(VisibilityContext);

  return (
    <div onClick={() => onClick(visibility)} className={className}>
      {children}
    </div>
  );
}
